/* eslint-disable */
import { inbound } from 'extActions';
import { userActions } from 'redux/actions';
import debounce from 'lodash.debounce';
import { store } from 'App';

const debouncedRequest = debounce((action) => {
	// firefox bug workaround -Amir
	if (action) {
		action();
	}
}, 500);

export const messageHandler = ({ data, handleData, dispatch }) => {
	const { user } = store.getState();
	switch (data.action) {
		case inbound.TEXTRECRUIT_DATA:
			return handleData(data);
		case inbound.DOMAIN_TO_EXCLUDE:
			if (!user.preferences.blacklistedDomains.includes(data.origin)) {
				const updatedBlacklistDomains = [data.origin, ...user.preferences.blacklistedDomains];
				/**
				 * Often times DOMAIN_TO_EXCLUDE message is posted multiple times (asynchronously)
				 * from the extension. This happens when the extension's content script is injected
				 * into multiple iframes.
				 * To prevent unnecessary identical API requests we are debouncing the
				 * required actions.
				 */
				debouncedRequest(() => dispatch(userActions.updateBlacklist({ updatedBlacklistDomains })));
			}
			break;
		case inbound.CURRENT_ORIGIN:
			const { origin, highlightEnabled } = data;
			const isInBlacklistedDomains = user.preferences.blacklistedDomains.includes(origin);
			if (highlightEnabled) {
				debouncedRequest(() => dispatch(userActions.toggleSwitch(true)));
			} else {
				debouncedRequest([() => dispatch(userActions.toggleSwitch(false))]);
				if (!isInBlacklistedDomains) {
					const updatedBlacklistDomains = [origin, ...user.preferences.blacklistedDomains];
					debouncedRequest(() =>
						dispatch(userActions.updateBlacklist({ updatedBlacklistDomains }))
					);
				}
			}
			break;
		default:
			return null;
	}
};
